export const Rule = {
    Campaign: 1,
    AdGroup: 2,
    ProductAd: 3,
    Keyword: 4,
}

export const Action = {
    IncreaseBidPercent: 1,
    IncreaseBidFlat: 2,
    IncreaseBudgetPercent: 3,
    IncreaseBudgetFlat: 4,
    Pause: 5,
    Resume: 6,
}

export const AmazonAPIState = {
    RESUME: 1,
    PAUSE: 2,
    ARCHIVE: 3,
}

export const RoundingStrategy = {
    ALWAYS_ROUND_UP: 1,
    ALWAYS_ROUND_DOWN: 2,
    NORMAL_ROUNDING: 3,
    WEIGHTED_ROUNDING: 4,
}

export const UpdateReportAdTypes = {
    Campaigns: 1,
    AdGroups: 2,
    ProductAds: 3,
    Keywords: 4,
    Targets: 5,
    CampaignNegativeKeywords: 6,
    NegativeKeywords: 7,
    NegativeTargets: 8,
    KeywordsAndTargets: 999,
    SearchTerms: 20,
}
export const ActionsList = {
    SetState: 1,
    SetDailyBudget: 2,
    SetDefaultBid: 3,
    SetBid: 4,
    CreateExactMatchNegative: 5,
    ChangeBiddingStrategy: 6,
    ChangeBidAdjustment: 7,
}
export const FrequenciesList = {
    AfterEveryDataSync: 1,
    OncePerDay: 2,
    Manually: 3,
    OnCertainDays: 4,
    AtACertainTime: 5,
    OnCertainDates: 6,
    Scheduled: 7,
}
export const NumericalChangeActions = {
    Set: 'set-to-$',
    IncreasePercent: 'increase-%',
    DecreasePercent: 'decrease-%',
    IncreaseDelta: 'increase-$',
    DecreaseDelta: 'decrease-$',
}
